import { styled } from '@stitches/react'

export const MobileMenuHeaderStyled = styled('div', {
  width: 'calc(100% - 32px)',
  height: '50px',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0px 22px 0px 16px',
  borderBottom: '0.5px solid #CACACA',
  background: '#ffffff',

  ['img']: {
    width: '30px',
    height: '30px',
  },
})

export const MobileMenuTitle = styled('div', {
  fontFamily: 'Open Sans, ',
  fontWeight: 300,
  color: '$mainTextColor',
  fontSize: '$lg',
  textTransform: 'capitalize',
  marginLeft: '12px',
  lineHeight: '28px',
})

export const MobileMenuHeaderLeft = styled('div', {
  display: 'flex',
  marginTop: '9px',

  ['> svg']: {
    height: '33px',
    width: '36px',
  },

  '@bp1': {
    marginTop: '$10',
  },
})
export const MobileMenuHeaderRight = styled('div', {
  display: 'flex',
  width: '35px',

  ['> svg']: {
    height: '24px',
    width: '24px',
  },
})
